import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router";
import { exchangeCodeForToken } from '../../../api/authentication/exchangeCodeForToken.ts';
import { setItem, getItem, removeItem } from '../utils/handleLocalStorage'
import { getOAuthUrl } from '../utils/oauthUrlConfig'
import { validateToken } from '../utils/validateToken'
import { useUser } from '../../../hooks/useUser';
import { AuthContext } from './AuthContext';
import { logoutUser } from '../hooks/logoutUser.ts'
import { toast } from 'react-toastify';
import { useLoadingNotification } from '@/hooks/useLoadingNotification.ts';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [token, setToken] = useState<string | null>(getItem('token') || null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const navigate = useNavigate();
  const { data: user, error: userError, isLoading: isGettingUserInfo } = useUser({ enabled: !!token });
  useLoadingNotification({ validator: isGettingUserInfo, message: "Cargando información del usuario..." });
  if (userError) {
    toast.error("Error al traer la información del usuario");
  }

  useEffect(() => {
    const validateTokenProvider = async () => {
      if (token) {
        const valid = await validateToken(token);
        if (valid) {
          setIsAuthenticated(true);
        } else {
          if (token !== null) {
            setToken(null);
            removeItem("token");
          }
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
    };

    validateTokenProvider();
  }, [token]);


  const authenticate = () => {
    const oauthUrl = getOAuthUrl();
    window.location.href = oauthUrl;
  }

  const handleOAuthCallback = async (code: string) => {
    if (isRequesting) return;

    const processedCode = getItem('oauthCodeProcessed');
    if (processedCode === code) return;

    setIsRequesting(true);
    try {
      setItem('oauthCodeProcessed', code);
      const token = await exchangeCodeForToken(code);

      if (token) {
        setItem('token', token);
        setIsAuthenticated(true);
        setToken(token);
        navigate('/');
      }
    } catch (error) {
      // TODO: poner trhow
      console.error("❌ Error en handleOAuthCallback:", error);
    } finally {
      setIsRequesting(false);
    }
  };

  const logout = async () => {
    await logoutUser();
    setIsAuthenticated(false);
    setToken(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isGettingUserInfo,
        token,
        isAuthenticated,
        authenticate,
        handleOAuthCallback: (code: string) => { void handleOAuthCallback(code); },
        logout: () => { void logout(); }
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}